export default __webpack_public_path__ + "static/contact-29bbb2ed94f89069cf6e6191c28ee92a.svg";